import {Component, OnInit} from '@angular/core';
import {ActivatedRoute} from "@angular/router";
import {PortalService} from "./services/portal.service";

/**
 * Special component for the step to stop the advisor because we can not offer anything to the user
 */
@Component({
    selector: 'app-advisor-pagenotfound',
    templateUrl: './advisor.pagenotfound.component.html',
    standalone: false
})
export class AdvisorPagenotfoundComponent implements OnInit {

  /**
   * The last step were we should navigate with the back button to.
   */
  lastStep: string = "/";

  /**
   * define the case why we stop here.
   */
  case: string = null;

  /**
   * constructor
   * @param portalService
   * @param activatedroute
   */
  constructor(private portalService: PortalService, private activatedroute: ActivatedRoute) {}

  /**
   * @inheritDoc
   */
  ngOnInit() {
    this.activatedroute.data.subscribe(data => {
      if(data.hasOwnProperty('advisor')) {
        this.lastStep = '/' + this.portalService.currentPortalId + '/' + data.advisor;
      }
    });
  }


}
